import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { appSettings } from "core/config";
import { BusinessPage } from "core/constants";
import { SelfServiceContext } from "core/context/self-service.context";
import { ModalAlert } from "components/common-ui";
import { PaymentsProps } from "self-service/dashboard/components/types";

const SaPaymentButton = observer((props: PaymentsProps) => {
    const { onClear } = props;
    const selfServiceContext = useContext(SelfServiceContext);
    const store = selfServiceContext.stores.amountToPay;
    const navigate = useNavigate();

    const [isPaymentEnabled, setIsPaymentEnabled] = useState(appSettings.isEnabled.payments);

    const makePayment = (event: any) => {
        if (event != null) {
            event.preventDefault();
        }

        onClear();
        navigate(BusinessPage.payment);
    }

    useEffect(() => {
        if (store.hasAmountToPayBeenSet && appSettings.isEnabled) {
            setIsPaymentEnabled(true);
        }
    }, [store.hasAmountToPay, isPaymentEnabled, store.hasAmountToPayBeenSet]);

    if (!isPaymentEnabled) {
        return null;
    }

    return (<button className="btn btn-primary" onClick={makePayment}>Pay Now</button>);
});

export default SaPaymentButton;
